import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    view: true,
    school: {}
  },

  mutations: {
    toggle_view (state, toggle) {
      state.view = toggle
    },

    selected_school (state, school) {
      state.school = school
    },
  },

  actions: {
  },

  getters: {
  }
})
